import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';

import ModalFormPage from '../../../../../styledComponents/ModalFormPage/ModalFormPage';

import { SmallModal } from '../../../../../styledComponents/ModalCommon/ModalCommon';
import { RESEND_AA_WELCOME_EMAIL_MODAL_NAME } from './resendAAWelcomeEmailModal.const';
import { withErrorProvider } from '../../../../../hoc/withErrorProvider';
import { useResendAAWelcomeEmailModalForm } from './resendAAWelcomeEmailModal.hooks';
import ResendWelcomeEmailForm from '../../../../../styledComponents/Forms/ResendWelcomeEmailForm/ResendWelcomeEmailForm';

type ResendAAWelcomeEmailModalProps = {
  id?: string;
};

const ResendAAWelcomeEmailModal = ({ id }: ResendAAWelcomeEmailModalProps) => {
  const { t } = useTranslation();
  const {
    submitHandler,
    onCancelHandler,
    welcomeEmailResending,
    initState,
    validateForm,
  } = useResendAAWelcomeEmailModalForm({ id });
  return (
    <SmallModal name={RESEND_AA_WELCOME_EMAIL_MODAL_NAME + id}>
      <Form
        keepDirtyOnReinitialize
        onSubmit={submitHandler}
        initialValues={initState}
        validate={validateForm}
      >
        {({ ...renderProps }) => (
          <ModalFormPage
            mode="small"
            handleSubmit={renderProps.handleSubmit}
            onCancel={onCancelHandler}
            title={t('headers.resend-welcome-email')}
            isProcessing={welcomeEmailResending}
          >
            <ResendWelcomeEmailForm disabled={welcomeEmailResending} />
          </ModalFormPage>
        )}
      </Form>
    </SmallModal>
  );
};

export default withErrorProvider(ResendAAWelcomeEmailModal);
